import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { X } from "lucide-react";
import { api } from "@/lib/api";
import { EFFECTS } from "@/components/decor/effects";
import { pageMatches } from "@/components/decor/constants";
import "@/components/decor/decor.css";

const useMedia = (q) => {
  const [m, setM] = useState(() => window.matchMedia(q).matches);
  useEffect(() => {
    const mq = window.matchMedia(q);
    const f = () => setM(mq.matches);
    mq.addEventListener("change", f);
    return () => mq.removeEventListener("change", f);
  }, [q]);
  return m;
};

const SeasonMessage = ({ s, preview }) => {
  const key = `lg-msg-${s.id}`;
  const [show, setShow] = useState(() => preview || !sessionStorage.getItem(key));
  useEffect(() => {
    if (!show) return undefined;
    sessionStorage.setItem(key, "1");
    const t = setTimeout(() => setShow(false), s.message.duration * 1000);
    return () => clearTimeout(t);
  }, [show, key, s.message.duration]);
  if (!show || !s.message.enabled) return null;
  return (
    <div className="lg-msg card-dark border-2 border-gold p-5 text-center shadow-2xl" role="status" data-testid={`decor-message-${s.id}`}>
      <button onClick={() => setShow(false)} aria-label="Cerrar mensaje" className="absolute right-2 top-2 rounded-full p-1 text-mute hover:text-ink" data-testid="decor-message-close-btn"><X size={16} /></button>
      <p className="font-display text-2xl font-black text-gold">{s.message.title}</p>
      {s.message.subtitle && <p className="mt-1 text-xs font-bold tracking-[0.2em] text-ink2">{s.message.subtitle}</p>}
      {s.message.text && <p className="mt-2 text-sm text-mute">{s.message.text}</p>}
    </div>
  );
};

export const DecorLayer = () => {
  const { pathname, search } = useLocation();
  const preview = new URLSearchParams(search).get("decor_preview") || "";
  const [seasons, setSeasons] = useState([]);
  const mobile = useMedia("(max-width: 767px)");
  const reduced = useMedia("(prefers-reduced-motion: reduce)");
  useEffect(() => {
    const load = () => api.get("/decorations/active", { params: preview ? { preview } : {} }).then((r) => setSeasons(r.data.seasons)).catch(() => setSeasons([]));
    load();
    const t = setInterval(load, 2 * 60 * 1000);
    return () => clearInterval(t);
  }, [preview]);
  const visible = seasons.filter((s) => pageMatches(s.pages, pathname));
  if (!visible.length) return null;
  return (
    <>
      {!reduced && (
        <div className="lg-decor" aria-hidden="true" data-testid="decor-layer">
          {visible.map((s) => Object.entries(s.effects).map(([k, e]) => {
            const C = EFFECTS[k];
            return C ? <C key={`${s.id}-${k}`} e={e} mobile={mobile} /> : null;
          }))}
        </div>
      )}
      {visible.map((s) => <SeasonMessage key={s.id} s={s} preview={!!preview} />)}
      {preview && <div className="fixed bottom-24 left-1/2 z-[60] -translate-x-1/2 rounded-full bg-black px-4 py-2 text-xs font-bold text-gold" data-testid="decor-preview-badge">Vista previa privada · solo tú la ves</div>}
    </>
  );
};
